export const OrgValue = {
    GI:'GI',
    MMT:'MMT'
}

export type Org = 'GI' | 'MMT'